import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Loading from '../images/loading.png'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner'
import {AiFillEye, AiFillCalendar, AiOutlineVideoCamera} from 'react-icons/ai'
import {BsPeopleFill} from 'react-icons/bs'
import {CgGym} from 'react-icons/cg'
import {GiKnifeFork} from 'react-icons/gi'
import {BiPackage, BiSearch, BiTimeFive} from 'react-icons/bi'
import {IoIosFitness, IoMdPeople, IoMdStats} from 'react-icons/io'
import {FiMessageSquare} from 'react-icons/fi'
import {FaCalendarAlt, FaNutritionix, FaUserAlt, FaUserCircle} from 'react-icons/fa'

  class Trainers extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        trainers: [],
        loading: false,
        search_query: null,
        session_price_range_start: null,
        session_price_range_end: null,
        program_price_range_start: null,
        program_price_range_stop: null,
        program_type: null,
        categories: [
          'Build Muscle', 'Loose Weight', 'Strength And Conditioning', 'Sports Perfomance', 'KickBoxing', 'Pilates', 'Spin Class', 'Toning',
          'Rehabilitation', 'Order Adults and Geriatic Care', 'Yoga', 'Wellness Monitoring'
        ]
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.CheckForTrainers = () => {
          var trainers = this.state.trainers

          if(trainers.length == 0){
              return<div>
                <br/>
                <h4 style={{marginTop: '80px', textAlign: 'center', marginBottom: '170px'}}>
                  No trainers found.
                </h4>
              </div>
          }else{
            var trainers = this.state.trainers
            var trainers_map = trainers.map((trainer, index) => {
                return<Col sm='3'>
                  <Container style={{borderRadius: '20px', backgroundColor: '#FFFFFF', marginBottom: '50px', borderRadius: '20px', overflowY: 'hidden', boxShadow: '0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12)'}}>
                    <a href={'/trainer/' + trainer._id.$oid} style={{color: 'inherit'}}>
                        <img src={Backend_Url + 'media/' + trainer.image} style={{width: '100%'}}/>
                        <h5 style={{marginTop: '10px', fontWeight: 'bold', color: '#47525E'}}>
                            {trainer.firstname} {trainer.lastname}
                        </h5>
                        <p style={{textAlign: 'left', marginTop: '5px', color: '#8190A5'}}>
                            {trainer.bio.substring(0, 100)} ...
                            <br/><br/>
                            <span style={{fontWeight: 'bold'}}>Click for more</span>
                        </p>
                        <br/> 
                    </a>
                  </Container>
                </Col>
            })
              return<Row>
                  {trainers_map}
              </Row>
          }
      }

      this.GetTrainers = () => {
      
        const { cookies } = this.props;
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
  
        axios.post(Backend_Url + 'getTrainers', data)
        .then((res) => {
            let result = res.data
            this.setState({trainers: result, loading: false})
        }).catch((error) => {
            console.log(error)
            this.GetTrainers()
        })
      }

      this.Search = () => {
        const { cookies } = this.props;

        if(
          (this.state.search_query == null) &&
          (this.state.session_price_range_start == null) &&
          (this.state.session_price_range_end == null) &&
          (this.state.program_price_range_start == null) &&
          (this.state.program_price_range_stop == null) &&
          (this.state.program_type == null)
        ){
          alert('Cannot run a search using empty parameters.')
        }else{
          this.setState({loading: true})
          var data = new FormData()
          data.append('search_query', this.state.search_query)
          data.append('session_price_range_start', this.state.session_price_range_start)
          data.append('session_price_range_end', this.state.session_price_range_end)
          data.append('program_price_range_start', this.state.program_price_range_start)
          data.append('program_price_range_stop', this.state.program_price_range_stop)
          data.append('program_type', this.state.program_type)
    
          axios.post(Backend_Url + 'trainerSearch', data)
          .then((res) => {
              let result = res.data
              this.setState({trainers: result, loading: false})
          }).catch((error) => {
              console.log(error)
              this.Search()
          })
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      this.GetTrainers()
    }




    render() {
      if(this.state.loading == true){
        return (
          <div style={{minHeight: '550px'}}>
            <Helmet>
            <title>Trainers - ONFIT</title>
            {/* <meta name="description" content="" /> */}
            </Helmet>
            <br/>
            <Container>
                <br/>
                <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                    ONFIT
                </h1>
                <br/><br/>
                <Triangle
                    color="#1FACED"
                    height={130}
                    width={130}
                />
                <h3 style={{marginTop: '50px'}}>
                Loading...
                </h3>
                <h6 style={{marginTop: '50px'}}>
                    Taking too long to load? Check your internet connection and reload the page.
                </h6>
                <br/><br/>
            </Container>
          </div>
        )
      }

      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>TRAINERS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <br/>
            <Container>
                <p style={{color: '#47525E', fontWeight: 'bold', textAlign: 'center', fontSize: '40px'}}>
                    TRAINERS
                </p>
                <br/>
                <Row style={{marginRight: '0px'}}>
                  <Col xs='10'>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Search query" type="text" name="search_query" id="search_query"
                        value={this.state.search_query} onChange={this.HandleChange} />
                  </Col>
                  <Col xs='2' style={{textAlign: 'left'}}>
                    <Button onClick={this.Search} style={{textAlign: 'center', border: 'none', backgroundColor: 'inherit', color: '#1faced'}}>
                      <BiSearch size='30px' style={{color: 'inherit'}}/>
                    </Button>
                  </Col>
                </Row>
                <br/>
                <Container>
                  <h6 style={{textAlign: 'left'}}>Filters:</h6>
                </Container>
                <Row>
                  <Col sm=''>
                    <Input style={{border: 'none', borderBottom: '1px solid silver', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Session price lower range" type="null" name="session_price_range_start" id="session_price_range_start"
                      value={this.state.session_price_range_start} onChange={this.HandleChange} />
                  </Col>
                  <Col sm=''>
                    <Input style={{border: 'none', borderBottom: '1px solid silver', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Session price upper range" type="null" name="session_price_range_end" id="session_price_range_end"
                      value={this.state.session_price_range_end} onChange={this.HandleChange} />
                  </Col>
                  <Col sm=''>
                    <Input style={{border: 'none', borderBottom: '1px solid silver', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Program price lower range" type="null" name="program_price_range_start" id="program_price_range_start"
                      value={this.state.program_price_range_start} onChange={this.HandleChange} />
                  </Col>
                  <Col sm=''>
                    <Input style={{border: 'none', borderBottom: '1px solid silver', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Program price upper range" type="null" name="program_price_range_stop" id="program_price_range_stop"
                      value={this.state.program_price_range_stop} onChange={this.HandleChange} />
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm='3'>
                    <select name='program_type' value={this.state.program_type} onChange={this.HandleChange} type='text'
                      style={{border: 'none', borderBottom: '1px solid silver', width: '100%', backgroundColor: 'inherit', marginTop: '7px'}}>
                        <option value={null}>Program Type</option>
                        {this.state.categories.map((category, index) => {
                            return<option value={category}>{category}</option>
                        })}
                    </select>
                  </Col>
                  <Col sm='3' style={{textAlign: 'left'}}>
                    <Button onClick={this.Search} style={{color: '#1faced', border: '1px solid #1faced', borderRadius: '20px', backgroundColor: '#ffffff'}}>
                      Search
                    </Button>
                  </Col>
                </Row>
                <br/><br/><br/>
                <this.CheckForTrainers/>
            </Container>
            <br/><br/><br/>
        </div>
      );
    }

  };
  
  export default withCookies(Trainers);